import { page } from './globalEvents';
import { myWalletClickHelper } from './helpers/index.js';

/**
 * @summary Sends GA Page event on Wallet Central
 */
export async function walletCentralPage(metadata, option) {
  page(metadata, option);
  return {};
}

/**
 * @summary Sends Pixall Click event on Sync Button Click
 */
export async function walletManualImportBtnClick(metadata, option) {
  const eventResult = `cta::confirm-manual::import-settings${metadata?.data?.isNew ? '::first-use' : ''}`;
  const {
    dataLayer
  } = metadata;
  myWalletClickHelper({
    withPixallData: true,
    dataLayer,
    pixallLabel: 'cta::confirm-manual::import-settings'
  }, option);
  return {
    eventResult
  };
}

/**
 * @summary Sends PixAll Click event on Import settings link click
 */
export async function walletImportSettingsClick(metadata, option) {
  const eventResult = 'text-link::import-settings';
  const {
    dataLayer = {}
  } = metadata;
  myWalletClickHelper({
    dataLayer,
    withPixallData: true,
    pixallLabel: eventResult
  }, option);
  return {
    eventResult
  };
}

/**
 * @summary Sends Pixall Click event on automatic sync
 */
export async function walletAutoSyncSuccess(metadata, option) {
  const {
    dataLayer = {}
  } = metadata;
  const eventResult = 'text-link::automatic::import-settings';
  myWalletClickHelper({
    dataLayer,
    withPixallData: true,
    pixallLabel: eventResult
  }, option);
  return {
    eventResult
  };
}

/**
 * @summary Sends Pixall Click event on Email Sync click
 */
export async function walletEmailSyncBtnClick(metadata, option) {
  const {
    dataLayer = {}
  } = metadata;
  const eventResult = 'cta::sync-now_email::my-wallet';
  myWalletClickHelper({
    dataLayer,
    withPixallData: true,
    pixallLabel: eventResult
  }, option);
  return {
    eventResult
  };
}

/**
 * @summary Sends Pixall Click event on footer click
 */
export async function walletIdSyncFooterClick(metadata, option) {
  const {
    dataLayer = {}
  } = metadata;
  const eventResult = 'text-link::where-is-my-wallet-id';
  myWalletClickHelper({
    dataLayer,
    withPixallData: true,
    pixallLabel: eventResult
  }, option);
  return {
    eventResult
  };
}
export default {
  walletCentralPage,
  walletManualImportBtnClick,
  walletImportSettingsClick,
  walletAutoSyncSuccess,
  walletEmailSyncBtnClick,
  walletIdSyncFooterClick
};